import script from "./loginSystem.vue?vue&type=script&setup=true&lang=js"
export * from "./loginSystem.vue?vue&type=script&setup=true&lang=js"

import "./loginSystem.vue?vue&type=style&index=0&id=3587e336&lang=scss&scoped=true"

import exportComponent from "F:\\嘉石BBS\\dd-jsbss\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3587e336"]])

export default __exports__